import InvertCrossIcon from './component'

export default InvertCrossIcon
